module.exports = __webpack_public_path__ + "img/3.ab485bc4.jpg";